module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Адрес</td>\n			<td><control type=\"text-area\" target=\"item.deliverypoints\"/></td>\n		</tr>\n		<tr>\n			<td>Город</td>\n			<td><control type=\"text\" target=\"item.city\"/></td>\n		</tr>\n		<tr>\n			<td>Область, край</td>\n			<td><control type=\"text\" target=\"item.admarea\"/></td>\n		</tr>\n		<tr>\n			<td>Индекс</td>\n			<td><control type=\"text\" target=\"item.postcode\"/></td>\n		</tr>\n		<tr>\n			<td>Страна</td>\n			<td><control type=\"text\" target=\"item.country\"/></td>\n		</tr>\n		<tr>\n			<td>Адреса электронных<br>почтовых ящиков</td>\n			<td><control type=\"text-area\" target=\"item.emails\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}